// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const DocumentPdfIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor" fillRule="evenodd">
      <path
        d="M20.71 9.1h-3.29c-1.96-.01-3.58-1.64-3.58-3.61V2c0-.28-.22-.5-.49-.5H7.63C4.96 1.5 2.8 3.7 2.8 6.38V14c0 .16.16.26.31.22q.38-.12.78-.12h1.49c1.02 0 1.94.35 2.68.93.1.08.25.06.33-.03.48-.56 1.2-.91 2-.91h1.24c.57 0 2.56.47 3.37 1.18.13.12.4.1.5-.04.48-.69 1.27-1.14 2.19-1.14h2.67q.28 0 .54.05c.15.03.3-.07.3-.22V9.58c0-.27-.23-.48-.49-.48"
        opacity=".5"
      />
      <path d="M5.38 19.26H4.7v-1.7h.7c.46 0 .85.38.85.85s-.39.85-.86.85m0-3.3H3.9c-.44 0-.8.36-.8.8v4.93c0 .44.36.8.8.8s.8-.36.8-.8v-.83h.7c1.35 0 2.45-1.1 2.45-2.45s-1.1-2.45-2.46-2.45m14.97-.01H17.7c-.45 0-.8.36-.8.8v4.95c0 .44.35.8.8.8.44 0 .8-.36.8-.8v-1.26h1.46c.45 0 .8-.36.8-.8s-.35-.8-.8-.8H18.5v-1.28h1.87c.45 0 .8-.36.8-.8s-.35-.8-.8-.8M12.8 20.4c-.3.32-.73.5-1.17.5h-.44v-3.34h.44q.68 0 1.18.49c.5.49.49.73.49 1.18q-.01.68-.5 1.18m-1.17-4.45h-1.24c-.44 0-.8.36-.8.8v4.95c0 .44.36.8.8.8h1.24c.87 0 1.7-.34 2.31-.96s.96-1.44.96-2.31-.34-1.7-.96-2.32-1.44-.96-2.31-.96m5.93-8.44h2.67c.45 0 .68-.54.37-.87L18.45 4.4l-2.17-2.28c-.32-.34-.88-.1-.88.36v2.85c0 1.2.98 2.19 2.16 2.19" />
    </g>
  </SvgIcon>
);

export default DocumentPdfIcon;
